import { type ThemeColors, colors, StyledIcon } from 'fitify-ui'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import {
  biggerPhone,
  phone,
  tabletPortrait,
} from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledHowItWorksIdContainer = styled.div`
  position: absolute;
  top: -72px;
  height: 72px;

  ${phone(css`
    top: 0;
  `)};
`
export const StyledHowItWorksItem = styled.div<{ $iconColor: ThemeColors }>`
  padding: 32px;
  border: 1px solid ${colors.Gray200};
  border-radius: 24px;
  background: ${colors.White};

  ${TextStyles} {
    &:not(:first-child) {
      margin-top: 16px;
    }
  }

  ${StyledIcon} {
    color: ${({ $iconColor }) => colors[$iconColor]};
  }
`
export const StyledHowItWorksItemWithButton = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding: 36px 32px 32px;
  border: 1px solid ${colors.Gray200};
  border-radius: 24px;
  background: ${colors.White};
  place-content: center center;
  text-align: center;
`
export const StyledHowItWorksList = styled.div<{ columns: number }>`
  display: grid;
  margin-top: 24px;
  gap: 24px;
  grid-auto-columns: 1fr;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  grid-template-rows: 1fr 1fr;

  ${tabletPortrait(css`
    margin-top: 24px;
    gap: 16px;
    grid-auto-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  `)};
  ${biggerPhone(css`
    margin-top: 24px;
    gap: 16px;
    grid-auto-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  `)};
  ${phone(css`
    margin-top: 24px;
    gap: 16px;
    grid-auto-columns: 1fr;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  `)};
`

export const StyledHowItWorksSection = styled.div`
  position: relative;
  padding-top: 120px;

  ${phone(css`
    padding-top: 80px;
  `)}
`
